import CollectionEditPage from './collectionEdit';

export default CollectionEditPage;
